import { Component } from '@angular/core';

@Component({
    selector: 'app-tool-request',
    templateUrl: './tool-request.component.html',
    styleUrls: ['./tool-request.component.scss']
})
export class ToolRequestComponent {
}
